module.exports = __webpack_public_path__ + "static/media/IN.6577f028.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IN.svg
// module id = 278
// module chunks = 0